import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {},
    storeButtonsWrapper: {
        marginTop: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3.5),
        },
    },
    storeButton: {
        display: 'inline-block',
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(1),
        },
    },
    stepsWrapper: {
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 8),
        },
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
    stepWrapper: {
        position: 'relative',
        marginTop: theme.spacing(14),
        [theme.breakpoints.down('lg')]: {
            marginTop: theme.spacing(10),
        },
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(10),
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(4),
        },
    },
    stepActivitiesWrapper: {
        marginLeft: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    stepSensorsWrapper: {
        marginLeft: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    stepEnrollWrapper: {
        marginLeft: theme.spacing(12),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    stepTrackWrapper: {
        marginLeft: theme.spacing(16),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    stepAdjustWrapper: {
        marginLeft: theme.spacing(20),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    stepImageWrapper: {
        paddingRight: theme.spacing(4.5),
        [theme.breakpoints.down('sm')]: {
            paddingRight: 0,
            paddingBottom: theme.spacing(2),
            textAlign: 'center',
            flexGrow: 1,
        },
    },
    stepImage: {
        display: 'block',
        width: [[240], '!important'],
        height: [[240], '!important'],
        paddingRight: theme.spacing(4.5),
        [theme.breakpoints.down('lg')]: {
            width: [[200], '!important'],
            height: [[200], '!important'],
        },
        [theme.breakpoints.down('md')]: {
            width: [[160], '!important'],
            height: [[160], '!important'],
        },
        [theme.breakpoints.down('sm')]: {
            width: [[120], '!important'],
            height: [[120], '!important'],
        },
    },
    colorPurple: {
        color: theme.palette.logo.purple.main,
    },
    arrowStepOneWrapper: {
        position: 'absolute',
        bottom: -160,
        right: -180,
        [theme.breakpoints.down('md')]: {
            bottom: -140,
            right: -180,
        },
    },
    arrowStepTwoWrapper: {
        position: 'absolute',
        bottom: -180,
        left: -90,
    },
    arrowStepThreeWrapper: {
        position: 'absolute',
        bottom: -170,
        right: -240,
        [theme.breakpoints.down('md')]: {
            bottom: -130,
            right: -210,
        },
    },
    arrowStepFourWrapper: {
        position: 'absolute',
        bottom: -180,
        left: -40,
    },
    arrowStepFiveWrapper: {
        position: 'absolute',
        bottom: -140,
        right: -200,
        [theme.breakpoints.down('md')]: {
            bottom: -130,
            right: -200,
        },
    },
    arrowSmallWrapper: {
        textAlign: 'center',
        paddingTop: theme.spacing(4),
    },
    bottomButtonsWrapper: {
        marginTop: theme.spacing(12),
        [theme.breakpoints.down('lg')]: {
            marginTop: theme.spacing(10),
        },
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(6),
        },
    },
}));
